import { ApiError } from '@/@types/generated'
import { useNavigate, useParams } from 'react-router'
import { CaseDetailsLayout } from '../components/CaseDetailsLayout'
import { CaseProvider } from '../hooks/case-provider'
import { useCallback } from 'react'
import { buildPath, Params } from '@/routes'
import { useError } from '@/hooks/useError'

export function CaseDetails() {
  // Hooks
  const { caseId } = useParams<Params<'/cases/:caseId'>>()
  const navigate = useNavigate()
  const { showError } = useError()

  const handleError = useCallback(
    (error: unknown) => {
      // Redirect to cases index if not found
      if (error instanceof ApiError && error.status === 404) {
        showError('Case not found')
        navigate(buildPath('/cases'))
      }
    },
    [navigate, showError]
  )

  return (
    <CaseProvider
      id={caseId ? Number(caseId) : undefined}
      onError={handleError}
    >
      <CaseDetailsLayout />
    </CaseProvider>
  )
}
